import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./../context/AuthContext";
import Loading from "../views/Loading";

export function ProtectedRoute({ element: Element, children, roles = [] }) {
  const { loading, isAuthenticated, hasPermission } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !hasPermission(roles)) {
    return <Navigate to="/error" replace />;
  }

  if (Element) {
    return <Element />;
  }

  return children ?? null;
}
